export const blockIconsPlacesEscalatorWarning = (
	<span className='material-symbols-outlined'>escalator_warning</span>
);
